import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '../../../01_atoms/FormElements';
import { required, valueNotIncludes } from '../../../../utils/formFieldValidators';

import styles from './index.module.scss';
import formattedTextStyles from '../../../01_atoms/FormattedText/index.module.scss';

const AddressSchemaFormManuallyUK = ({ changeSchemaType, autoSwitched }) => (
  <div className={styles['address-uk-manually']}>
    <div className="row">
      <div className="col-sm-6 mb-0">
        <TextField
          key="address.postalCode"
          name="address.postalCode"
          label="Postcode"
          autoComplete="postal-code"
          placeholder="SA0 000"
          validate={required('Please enter your postcode')}
          isRequired
        />
      </div>
    </div>

    <TextField
      key="address.addressLine1"
      name="address.addressLine1"
      label="Address"
      autoComplete="address-line1"
      placeholder="Line 1"
      validate={required('Please enter your address')}
      isRequired
    />

    <TextField
      key="address.addressLine2"
      name="address.addressLine2"
      autoComplete="address-line2"
      placeholder="Line 2 (optional)"
    />

    <div className="row">
      <div className="col-sm mb-0">
        <TextField
          key="address.locality"
          name="address.locality"
          label="Town"
          validate={required('Please add town/city for this address')}
          isRequired
          placeholder=" "
        />
      </div>
      <div className="col-sm mb-0">
        <TextField
          key="address.administrativeArea.GB"
          name="address.administrativeArea.GB"
          label="County"
          validate={valueNotIncludes('select', 'Please make sure the county is correct')}
          placeholder=" "
        />
      </div>
    </div>

    {autoSwitched ? (
      <div className={`${styles['helper-text']} ${formattedTextStyles['formatted-text']}`}>
        Wrong address?&nbsp;
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            changeSchemaType();
          }}
        >
          Search again
        </a>
      </div>
    ) : (
      <div className={`${styles['helper-text']} ${formattedTextStyles['formatted-text']}`}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            changeSchemaType();
          }}
        >
          Search for an address by postcode
        </a>
      </div>
    )}
  </div>
);

AddressSchemaFormManuallyUK.propTypes = {
  changeSchemaType: PropTypes.func.isRequired,
  autoSwitched: PropTypes.bool.isRequired,
};

export default AddressSchemaFormManuallyUK;
